type TranslationFn = (key: string) => string

export function getCancelledStatusLabel(
  initiatedBy: string | null | undefined,
  fallbackLabel: string,
  t: TranslationFn,
): string {
  if (initiatedBy === 'BUYER') return t('common.status.cancelledByBuyer')
  return fallbackLabel
}
